module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('button', {
    staticClass: "current",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('language')) + "\n  ")]), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "options"
  }, _vm._l((_vm.locales), function(locale) {
    return _c('button', {
      staticClass: "option",
      on: {
        "click": function($event) {
          _vm.setLocale(locale.code)
        }
      }
    }, [_vm._v("\n      " + _vm._s(locale.name) + "\n    ")])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7fa68512!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locale.vue
// module id = 183
// module chunks = 2